module.exports = __webpack_public_path__ + "img/syringe.9378fe1c.svg";